<template>
  <div class="side-panel">
    <v-layout white>
      <search-bar @search="filteredUsers = filterTable(users, $event)" :columns="headers"></search-bar>
      <v-spacer></v-spacer>
      <!-- <v-flex align-self-center shrink>
        <v-btn
          @click="createGroupModalVisible = true"
          class="secondary"
          medium>
          Create user
        </v-btn>
      </v-flex> -->
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="filteredUsers"
      :loading="loading && this.error === null"
      hide-actions
    >
        <template slot="items" slot-scope="props">
          <tr @click="editUserModalVisible = true; clickedId = props.item.id">
            <td class="text-xs-center" >{{ props.item.id }}</td>
            <td class="text-xs-center">{{ props.item.username }}</td>
            <td class="text-xs-center">{{ props.item.first_name }}</td>
            <td class="text-xs-center">{{ props.item.last_name }}</td>
            <td class="text-xs-center">{{ props.item.phone_number }}</td>
            <td class="text-xs-center">{{ props.item.role_type ? $t(`roleNames.${props.item.role_type}`) : 'N/A' }}</td>
            <td class="text-xs-center">{{ props.item.company_id }}</td>
            <td class="text-xs-center">{{ props.item.company_name }}</td>
            <!-- <td class="text-xs-center">{{ props.item.buildingID ? props.item.buildingID : 'N/A' }}</td> -->
            <td class="text-xs-right">{{ props.item.enabled }}</td> -->
          </tr> 
        </template>
    </v-data-table>
  <v-dialog v-model="editUserModalVisible" max-width="500px">
    <edit-user v-on:close="editUserModalVisible = false; loadData()" :clickedId="this.clickedId"></edit-user>
  </v-dialog>   
  </div>  
</template>

<script>
import UsersService from '@/services/UsersService'
import EditUser from '@/components/EditUser'
import FilterTable from '@/helpers/FilterTable.js'

export default {
  components: {
    EditUser
  },
  mixins: [FilterTable],
  data () {
    return {
      headers: [
        { text: this.$t('userGenerics.userId'),
          align: 'center',
          sortable: true,
          value: 'id' },
        { text: this.$t('userGenerics.email'),
          value: 'username',
          align: 'center' },
        { text: this.$t('userGenerics.firstName'),
          value: 'first_name',
          align: 'center' },
        { text: this.$t('userGenerics.lastName'),
          value: 'last_name',
          align: 'center' },
        { text: this.$t('userDetail.phoneNum'),
          value: 'phone_number',
          align: 'center' },
        { text: this.$t('roleGenerics.roleType'),
          value: 'role_type',
          align: 'center' },
        { text: this.$t('companyGenerics.companyId'),
          value: 'company_id',
          align: 'center' },
        { text: this.$t('companyGenerics.companyName'),
          value: 'company_name',
          align: 'center' },
        // { text: this.$t('buildingGenerics.buildingId'),
        //   value: 'buildingID',
        //   align: 'center' }
      ],
      users: [],
      data: [],
      loading: null,
      error: null,
      editUserModalVisible: false,
      clickedId: null,
      filteredUsers: []
    }
  },
  async mounted () {
    await this.loadData()
  },
  methods: {
    async loadData () {
      try {
        this.error = null
        this.loading = true
        const request = (await UsersService.list(true));
        // Map company data and users into one object
        const mapped_data = request.data.map(user => Object.assign({}, user, user.company || {}))

        this.users = mapped_data
        this.filteredUsers = mapped_data;
        this.loading = false
      } catch (err) {
        console.log(err)
        this.error = err.response.data.error.message
      }
    }
  }
}
</script>

<style scoped>
tr {
  cursor: pointer
}
</style>



// WEBPACK FOOTER //
// src/components/Users.vue